import React, { createContext, useContext, useEffect, useState } from "react";
import Loading from "../components/Loading";
import { getCookie } from "../utilities/cookies";
import { env, handleAxiosError } from "../utilities/function";
import axios from "axios";
// import Setup from '../components/Setup';
import { useMessage } from "../components/Header";
import { setCookie } from "../utilities/cookies";
import { saveIntendedRoute } from "../utils/routePreservation";

const authorizeContext = createContext();

const authServer = axios.create({
  baseURL: env("AUTHENTICATION_SERVER"),
});

const accessToken = getCookie("clikkleStoreAccessToken");
authServer.defaults.withCredentials = false;
authServer.defaults.headers.Authorization = `Bearer ${accessToken}`;

const AuthorizationProvider = ({ children }) => {
  const [content, setContent] = useState(
    <Loading message="Please wait, logging you in..." />
  );
  const [user, setUser] = useState({});
  const { showError } = useMessage();
  // const signOut = () => {
  //   localStorage.removeItem("subscriptionId");
  //   localStorage.removeItem("org");
  //   localStorage.removeItem("user");
  //   const redirectTo =
  //     env("AUTHENTICATION_CLIENT") +
  //     "/logout?redirectto=" +
  //     encodeURIComponent(env("DOMAIN")) +
  //     "&&referrer=" +
  //     encodeURIComponent(env("DOMAIN"));

  //   setContent(
  //     <Loading
  //       message="Some thing went worng please try again some time later"
  //       redirectTo={redirectTo}
  //     />
  //   );
  // };

  const authorize = async (loggedIn, cb) => {
    if (loggedIn) {
      setContent(children);
    } else {
      // Save current route as intended route before redirecting to login
      saveIntendedRoute(window.location.pathname, window.location.search, window.location.hash);

      const redirectTo = "/login";
      setContent(
        <Loading
          message="Please wait, redirecting you to Login page..."
          redirectTo={redirectTo}
        />
      );
    }
    if (typeof cb === "function") cb(setUser);
  };
  const createSession = async (refreshToken, user) => {
    authorize(true, (setUser) => setUser(user));

    // try {

    //   const response = await axios.post(`/open/session`, {
    //     refreshToken,
    //     userId: user._id,
    //     userType: "store",
    //   });
    //   let data = response.data;
    //   if (data.success === true) {
    //     if (data.token) {
    //       setCookie("clikkleStoreAccessToken", data.token);
    //       localStorage.setItem("user", JSON.stringify(data.user));
    //     }
    //     // getSubscription(data.user?._id)

    //     try {
    //       const userDetailsResponse = await axios.get(
    //         `https://api.files.clikkle.com/api/subscription/${user._id}`
    //       );
    //       const userDetails = userDetailsResponse.data;
    //       localStorage.setItem("storage", JSON.stringify(userDetails));
    //       const subscriptionResponse = await axios.get(
    //         `https://api.files.clikkle.com/api/user/${user._id}`
    //       );

    //       const subscriptionData = subscriptionResponse.data;
    //       localStorage.setItem("userStorage", JSON.stringify(subscriptionData));
    //     } catch (error) {
    //       console.warn("Subscription API 2 failed", error);
    //     }

    //     authorize(true, (setUser) => setUser(user));
    //   } else {
    //     // authorize(true, (setUser) => setUser(user));
    //     //  setTimeout(() => {
    //     //   signOut();
    //     // }, [6000]);
    //   }
    // } catch (e) {
    //   authorize(true, (setUser) => setUser(user));
    //   //  setTimeout(() => {
    //   //    signOut();
    //   //    }, [6000]);
    // }
  };
  // const signOut = () => {
  //   localStorage.removeItem("user");
  //   const redirectTo =
  //     env("AUTHENTICATION_CLIENT") +
  //     "/logout?redirectto=" +
  //     encodeURIComponent(env("DOMAIN")) +
  //     "&&referrer=" +
  //     encodeURIComponent(env("DOMAIN"));

  //   setContent(
  //     <Loading
  //       message="Some thing went worng please try again some time later"
  //       redirectTo={redirectTo}
  //     />
  //   );
  // };

  useEffect(() => {
    (async () => {
      try {
        // const role = getCookie('role');
        // if (!role) throw new Error('role not found');
        // const response = await authServer.get(`/${role}/profile`);
        // const user = response.data.user;

        // authorize(true, setUser => setUser(user));
        const queryParameters = new URLSearchParams(window.location.search);
        const queryUserId = queryParameters.get("userId");
        const isValidObjectId = queryUserId && /^[0-9a-fA-F]{24}$/.test(queryUserId);
        let userId = isValidObjectId ? queryUserId : JSON.parse(localStorage.getItem('user'))?._id;
        let refreshToken = queryParameters.get("refreshToken") || localStorage.getItem("refreshToken") || JSON.parse(localStorage.getItem("clikkleStoreAccessToken"));

        if (!userId) {
          userId = JSON.parse(localStorage.getItem('user'))?._id;
        }

        if (!refreshToken) {
          refreshToken = getCookie("refreshToken");
        }

        if (userId) {
          if (refreshToken) {
            setCookie("refreshToken", refreshToken);
          }
          if (userId) {
            setCookie("userId", userId);
          }

          // Check if we already have this user and token to avoid redundant fetch
          const storedUser = JSON.parse(localStorage.getItem('user'));
          const storedToken = getCookie("refreshToken") || localStorage.getItem("refreshToken");
          
          if (storedUser?._id === userId && storedToken === refreshToken && storedToken) {
            console.log("User already logged in with these credentials, skipping fetch");
            await createSession(refreshToken, storedUser);
            
            // Clean up URL parameters
            const url = new URL(window.location.href);
            url.searchParams.delete("userId");
            url.searchParams.delete("refreshToken");
            window.history.replaceState({}, "", url.toString());
            return;
          }

          var formData = new FormData();
          formData.append("id", userId);

          const response = await fetch(
            "https://api.accounts.clikkle.com/api/auth/get_user_profile",
            {
              method: "POST",
              body: formData,
            }
          );
          if (response.ok) {
            console.log("user found ...");
            const responseData = await response.json();
            let { user } = responseData;
            user.refreshToken = refreshToken;
            localStorage.setItem("user", JSON.stringify(user));
            await createSession(refreshToken, user);
            
            // Clean up URL parameters after successful login
            const url = new URL(window.location.href);
            url.searchParams.delete("userId");
            url.searchParams.delete("refreshToken");
            window.history.replaceState({}, "", url.toString());
          } else {
            console.log("user not found");
            authorize(false);
          }
        } else if (localStorage.getItem("user")) {
          let user = JSON.parse(localStorage.getItem("user"));
          const storedRefreshToken = refreshToken || user.refreshToken;
          if (refreshToken) {
            setCookie("refreshToken", refreshToken);
            user.refreshToken = refreshToken;
            localStorage.setItem("user", JSON.stringify(user));
          }
          await createSession(storedRefreshToken, user);
        } else {
          authorize(false);
        }
      } catch (err) {
        console.log(err);
        handleAxiosError(err, showError);
        authorize(false);
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <authorizeContext.Provider value={{ authorize, setUser, user, setContent }}>
      {content}
    </authorizeContext.Provider>
  );
};

const useAuthorize = () => useContext(authorizeContext).authorize;
const useUser = () => useContext(authorizeContext)?.user;
const useSetUser = () => useContext(authorizeContext).setUser;
const useSetContent = () => useContext(authorizeContext).setContent;

export default AuthorizationProvider;
export { useAuthorize, useUser, useSetUser, useSetContent };
